import React from "react";

const Map = () => {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d111497.07331468642!2d75.6731372333465!3d29.15631570806628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391232d8011d0c37%3A0x1d3f0df105af1178!2sHisar%2C%20Haryana!5e0!3m2!1sen!2sin!4v1743863969313!5m2!1sen!2sin"
      width="511"
      height="480"
      className="border-0 rounded-xl max-xl:w-full 2xl:w-full max-lg:h-96"
      allowfullscreen="true"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    />
  );
};

export default Map;
